import { IValidator, IValidations, IClientCalendar } from '@/interfaces';
import { CalendarSessionValidator } from './CalendarSessionValidator';

export class CalendarValidator implements IValidator<IClientCalendar> {
  public isValid(item: IClientCalendar) {
    const errors: IValidations<IClientCalendar> = {};
    if (item.priceCategoryId === null) errors.priceCategoryId = ['Price Category is Required'];
    if (item.name.length === 0) errors.name = ['Session Name is Required'];
    if (item.sessions === undefined || item.sessions.length === 0) errors.sessions = ['Sessions are required'];

    const validator = new CalendarSessionValidator();
    const sessionErrors = item.sessions?.map(x => validator.isValid(x)).filter(x => x !== true) ?? [];
    if (sessionErrors.length > 0) errors.sessions = ['Sessions Have Errors'];
    return Object.keys(errors).length > 0 ? errors : true;
  }
}